import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Pagination from "../components/Pagination";

function LogAlarmas() {
  const [logAlarmas, setLogAlarmas] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [pageSize, setPageSize] = useState(10);  // 👈 Valor por defecto: 25
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const [modalObert, setModalObert] = useState(false);
  const [dataInici, setDataInici] = useState(obtenirDataFaUnaSetmana());
  const [dataFinal, setDataFinal] = useState(obtenirDataAvui());

  function obtenirDataAvui() {
    return new Date().toISOString().split('T')[0]; // "2025-03-28"
  }
  
  function obtenirDataFaUnaSetmana() {
    const avui = new Date();
    avui.setDate(avui.getDate() - 7);
    return avui.toISOString().split('T')[0]; // "2025-03-21"
  }
  
  const descarregarCSV = () => {
    const url = `${API_URL}/api/descarregar-csv/?data_inici=${dataInici}&data_final=${dataFinal}`;
    window.open(url, "_blank");
    setModalObert(false);
  };

  // ✅ Usa useCallback para evitar re-renderizados innecesarios
  const fetchLogAlarmas = useCallback((url = `${API_URL}/api/log-alarmas/?page_size=${pageSize}`) => {
    axios.get(url)
      .then(response => {
        setLogAlarmas(response.data.results);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      })
      .catch(error => console.error("Error al obtener el log de alarmas:", error));
  }, [API_URL, pageSize]);  // ✅ Solo cambiará si API_URL cambia

  useEffect(() => {
    // Siempre carga desde la primera página al cambiar el pageSize
    fetchLogAlarmas(`${API_URL}/api/log-alarmas/?page_size=${pageSize}`);
  }, [pageSize, fetchLogAlarmas]);

  return (
    <div>
      <h2>📜 Log de Alarmas</h2>
      <div className="contenedor">
      <button className="btn-descarregar" onClick={() => setModalObert(true)}>
        📥  Descargar CSV
      </button>

      {modalObert && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>📅 Seleciona periodo</h3>

            <div className="filtres-data">
              <label>Fecha Inicio:</label>
              <input type="date" value={dataInici} onChange={(e) => setDataInici(e.target.value)} />

              <label>Fecha Final:</label>
              <input type="date" value={dataFinal} onChange={(e) => setDataFinal(e.target.value)} />
            </div>

            <div className="modal-botons">
              <button className="btn-confirmar" onClick={descarregarCSV}>
                ✅ Confirmar
              </button>
              <button className="btn-cancelar" onClick={() => setModalObert(false)}>
                ❌ Cancelar
              </button>
            </div>
          </div>
        </div>
       )}
       <style>
        {`
          .filtres-data {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 20px;
          }
          .filtres-data label {
            font-weight: bold;
          }
          .filtres-data input {
            padding: 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
          }
          .btn-descarregar {
            background-color: #28a745;
            color: white;
            border: none;
            padding: 8px 15px;
            border-radius: 5px;
            cursor: pointer;
          }
          .btn-descarregar:hover {
            background-color: #218838;
          }
        `}
        </style>

        {/* 🔽 Selector de número de registros */}
        <div className="d-flex align-items-center mb-3">
          <label htmlFor="pageSizeSelect" className="form-label me-2">Registros:</label>
          <select
            id="pageSizeSelect"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="form-select"
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Fecha</th>
              <th>Nombre Alarma</th>
              <th>Estado</th>
              <th>Notificada</th>
              <th>Confirmada</th>
              <th>Mensaje</th>
            </tr>
          </thead>
          <tbody>
            {logAlarmas.map(alarma => (
              <tr key={alarma.id}>
                <td>{alarma.id}</td>
                <td>{new Date(alarma.fecha_hora).toLocaleString()}</td>
                <td>{alarma.nombre_alarma}</td>
                <td>
                  <span className={`badge ${alarma.estado === "ACTIVA" ? "bg-danger" : "bg-success"}`}>
                    {alarma.estado}
                  </span>
                </td>
                <td>
                  <span className={`badge ${alarma.notificada ? "bg-info text-dark" : "bg-secondary"}`}>
                    {alarma.notificada ? "Notificada" : "No Notificada"}
                  </span>
                </td>
                <td>
                  <span className={`badge ${alarma.confirmada ? "bg-success" : "bg-warning text-dark"}`}>
                    {alarma.confirmada ? "Confirmada" : "No Confirmada"}
                  </span>
                </td>
                <td>{alarma.mensaje}</td>
              </tr>
            ))}
          </tbody>
        </table>

         {/* 🔵 Paginación Reutilizable */}
         <Pagination 
          prevPage={prevPage} 
          nextPage={nextPage} 
          fetchPage={fetchLogAlarmas} 
        />
      </div>
    </div>
  );
}

export default LogAlarmas;
